// extracted by mini-css-extract-plugin
export var cardIcon = "_p-5";
export var cardIconUnframed = "_p-9";
export var checkboxCard = "_p-0";
export var checkboxCardSelected = "_p-4";
export var disabled = "_p-2";
export var interactive = "_p-1";
export var outerBorder = "_p-3";
export var spacerMedium = "_p-8";
export var spacerSmall = "_p-7";
export var spacerXsmall = "_p-6";